export const TagValueEnum={
    SAVINGS:"SAVINGS",
    AADHAARMASKING:"AADHAARMASKING",
    NROSAVINGS: "NRO_SAVINGS"
};